import React from 'react';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import Divider from '@/components/UI/divider/Divider';
import styles from './HostProfileSkeleton.module.scss';
const HostProfileSkeleton = () => {
  return <Box className={styles['host-profile']} data-sentry-element="Box" data-sentry-component="HostProfileSkeleton" data-sentry-source-file="HostProfileSkeleton.tsx">
      <Box className={styles['host-profile-header']} data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
        <Skeleton variant="circular" width={54} height={54} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
        <Box className={styles['host-profile-header-title']} data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
          <Skeleton width={150} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
          <Skeleton width={165} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
        </Box>
      </Box>

      <Divider data-sentry-element="Divider" data-sentry-source-file="HostProfileSkeleton.tsx" />

      <Box className={styles['host-profile-footer']} data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
        <Box className={styles['host-profile-footer-section']} data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
          <Skeleton width={32} height={32} variant="rounded" data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
          <Box data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
            <Skeleton width={85} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
            <Skeleton width={85} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
          </Box>
        </Box>

        <Box className={styles['host-profile-footer-section']} data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
          <Skeleton width={32} height={32} variant="rounded" data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
          <Box data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
            <Skeleton width={85} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
            <Skeleton width={85} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
          </Box>
        </Box>

        <Box className={styles['host-profile-footer-section']} data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
          <Skeleton width={32} height={32} variant="rounded" data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
          <Box data-sentry-element="Box" data-sentry-source-file="HostProfileSkeleton.tsx">
            <Skeleton width={85} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
            <Skeleton width={85} data-sentry-element="Skeleton" data-sentry-source-file="HostProfileSkeleton.tsx" />
          </Box>
        </Box>
      </Box>
    </Box>;
};
export default HostProfileSkeleton;